// @ts-check
/**
 * @global globalThis {matchDayCountdown: any }
 */

import {
  differenceInDays,
  differenceInMilliseconds,
  differenceInMinutes,
  formatDistanceToNowStrict,
  getMilliseconds,
  intervalToDuration,
  isAfter,
  secondsToMilliseconds,
  startOfMinute,
  subSeconds,
} from "date-fns";

(function () {
  if (!globalThis.matchDayCountdown) return false;

  const {
    countdown_label,
    countdown_label_dayof,
    datetime,
    match_day_label,
    match_day_title,
  } = globalThis.matchDayCountdown;

  const matchDateTime = new Date(datetime);

  const updateCountdown = () => {
    let title, label, refreshDelay;
    const now = new Date();
    const div = document.querySelector(".match-day-countdown__content");

    if (isAfter(now, matchDateTime)) {
      /**
       * After Match Day
       */
      title = match_day_title;
      label = match_day_label;
      refreshDelay = 0;
    } else if (differenceInMinutes(matchDateTime, now) < 15) {
      /**
       * Less than 15 minutes
       */
      const timeLeft = intervalToDuration({
        start: subSeconds(now, 1),
        end: matchDateTime,
      });
      const minutes = ("0" + timeLeft.minutes).slice(-2);
      const seconds = ("0" + timeLeft.seconds).slice(-2);
      title = `${minutes}:${seconds}`;
      label = countdown_label_dayof;

      /**
       * Sync refresh to second boundaries
       */
      refreshDelay = 1000 - getMilliseconds(now);
    } else {
      /**
       * More than 24 hours (days)
       * Everything over 15 minutes can use formatDistanceToNowStrict
       * @link https://date-fns.org/v2.29.3/docs/formatDistanceToNowStrict
       */
      const diffDays = differenceInDays(matchDateTime, now);
      const unit = diffDays > 2 ? "day" : undefined;
      title = formatDistanceToNowStrict(matchDateTime, { unit });
      label = diffDays < 2 ? countdown_label_dayof : countdown_label;

      /**
       * Sync refresh to 10-second boundaries
       */
      const minuteOffset = differenceInMilliseconds(now, startOfMinute(now));
      const tenSeconds = secondsToMilliseconds(10);
      refreshDelay = tenSeconds - (minuteOffset % tenSeconds);
    }

    if (div) {
      div.innerHTML = `<strong>${title}</strong> ${label}`;
    }

    if (refreshDelay > 0) {
      setTimeout(updateCountdown, refreshDelay);
    }
  };

  updateCountdown();
})();
